/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Steps_Title_TailInputs */

const en_portal_steps_title_tail = /** @type {(inputs: Portal_Steps_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and you are training.`)
};

const pl_portal_steps_title_tail = /** @type {(inputs: Portal_Steps_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i jesteś na treningu.`)
};

/**
* | output |
* | --- |
* | "and you are training." |
*
* @param {Portal_Steps_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_steps_title_tail = /** @type {((inputs?: Portal_Steps_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Steps_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_steps_title_tail(inputs)
	return en_portal_steps_title_tail(inputs)
});